
<div>
	<v-container class="pa-1 pb-0 text-center">
		<v-card-title class="mb-1 justify-center"><h1>Rates</h1></v-card-title>
		<v-card-text v-if="!hasFixedRates">
			{{ getLabel('ratesSectionHourlyRateText', 'Enter your desired HOURLY Locum rate. Should you need guidance, see our average rates') }}
			<!-- TODO: Get link from tenant configuration, temporarily we get it from label config -->
			<a :href="getLabel('ratesSectionHourlyRateLink', 'https://www.locumbase.com/rate-card')" target="_blank">{{
				getLabel('ratesSectionHourlyRateLinkText', 'here')
			}}</a>
		</v-card-text>
		<v-card-text v-else>
			{{
				getLabel(
					'ratesSectionFixedRateText',
					'Rates for your selected industry are standard across the platform. This ensures fair trading of your time and affordability to the booking practice.'
				)
			}}
		</v-card-text>
	</v-container>

	<v-card-text align="center" justify="center" class="justify-center text-left pb-0 pm-0">
		<locum-rates-form :solo="false"></locum-rates-form>
	</v-card-text>
</div>
